import React from 'react';
import InfoTooltip from '../InfoTooltip';

const ScreeningBox = ({ finalTP, prevalence, sensitivity, specificity }) => {
  const baseline = finalTP / prevalence;

  const sampleSizeStep1 = Math.ceil(finalTP / (sensitivity * prevalence));
  const sampleSizeStep2 = Math.ceil((sensitivity * prevalence + (1 - specificity) * (1 - prevalence)) * sampleSizeStep1);
  
  const percentageChange = 100 * sampleSizeStep2 / baseline - 100;

  const infoStyle = percentageChange > 0 ? { color: 'green' } : { color: 'red' };
  const iconName = percentageChange > 0 ? 'arrow-up' : 'arrow-down';

  return (
    <div className="p-3 card gradient1">
      <h4 className='d-flex'>Screening <InfoTooltip tooltipTextKey="tooltip_screening_box" color="white" /></h4>
      <div className="card-body">
        <div className="info" style={infoStyle}>
          <h5>{sampleSizeStep2.toLocaleString()}</h5>
          <h6>{percentageChange.toFixed(2)}% <i className={`fas fa-${iconName}`}></i></h6>
        </div>
      </div>
    </div>
  );
};

export default ScreeningBox;
